import { defineStore } from 'pinia'
import { ref } from 'vue'
import { client } from '@/api/orpc'

export const useRain = defineStore('rain', () => {
	const available = ref(false)
	const status = ref<'pending' | 'active'>('pending')
	const endsAt = ref<number>()
	const pool = ref<number>(0)
	const joined = ref(false)
	const show = ref(false)

	const setJoined = (value: boolean) => {
		joined.value = value
	}

	const setPool = (value: number) => {
		pool.value = value
	}

	const setRain = (rain?: {
		status: 'pending' | 'active'
		endsAt?: number
		pool: number
		joined?: boolean
	}) => {
		if (!rain) {
			available.value = false
			return
		}

		available.value = true
		status.value = rain.status
		endsAt.value = rain.endsAt
		setPool(rain.pool)

		if (rain.joined !== undefined) {
			setJoined(rain.joined)
		}

		if (status.value === 'active') {
			open()
		}
	}

	const subToRain = async () => {
		const { data: iterator, error } = await client.user.subRainUpdates(
			{},
			{
				context: {
					retry: Number.POSITIVE_INFINITY
				}
			}
		)

		if (error) {
			return console.error(error)
		}

		if (!iterator) {
			return
		}

		try {
			for await (const event of iterator) {
				if (!available.value) {
					setRain({
						joined: false,
						pool: event.pool,
						endsAt: event.endsAt || undefined,
						status: event.status
					})
					continue
				}

				setRain({
					pool: event.pool,
					endsAt: event.endsAt || undefined,
					status: event.status
				})
			}
		} catch (error: unknown) {
			console.error('ERROR IN RAIN SUB', error)
		}
	}

	const open = () => {
		if (show.value) {
			return
		}

		show.value = true
	}

	const close = () => {
		if (!show.value) {
			return
		}

		show.value = false
	}

	return {
		available,
		status,
		endsAt,
		pool,
		joined,
		show,
		setJoined,
		subToRain,
		setRain,
		open,
		close,
		setPool
	}
})
